import React from 'react';
import type { FC } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ContentAnalyticsLink } from '../ContentAnalyticsLink/ContentAnalyticsLink.tsx';
import { TestId } from '../dialogConstants.tsx';
import { AnalyticsDialogFooterSkeleton } from '../LoadingSkeleton/index.ts';

import * as S from './styled.tsx';

export type AnalyticsDialogFooterProps = {
	isCompactLayout?: boolean;
	isLoading: boolean;
	contentId: string;
	contentTab?: 'Overview' | 'Mentions' | 'Links';
	onClickAnalyticsLink?: () => void;
};

const i18n = defineMessages({
	viewMoreInsightsButton: {
		id: 'confluence-analytics.view-more-insights.button',
		defaultMessage: 'View more insights',
		description: 'A label on a button to view more analytics.',
	},
});

export const AnalyticsDialogFooter: FC<AnalyticsDialogFooterProps> = ({
	isCompactLayout = false,
	isLoading,
	contentId,
	contentTab,
	onClickAnalyticsLink,
}) => {
	return (
		<>
			{isLoading ? (
				<AnalyticsDialogFooterSkeleton data-testid={TestId.LINK_SKELETON} />
			) : (
				<S.FooterContainer>
					<ContentAnalyticsLink
						isCompactLayout={isCompactLayout}
						contentId={contentId}
						contentTab={contentTab}
						testId={TestId.LINK}
						onClick={onClickAnalyticsLink}
					>
						<FormattedMessage {...i18n.viewMoreInsightsButton} />
					</ContentAnalyticsLink>
				</S.FooterContainer>
			)}
		</>
	);
};
